module.exports = __webpack_public_path__ + "img/Skirt-Back-B5-Da-Ga-Ha-Ia-Ga.f3b9535b.png";